import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import CcmCampaignPaymentsEmptyInvoice from './empty/CcmCampaignPaymentsEmptyInvoice';
import CcmCampaignPaymentsWithDataInvoice from './with-data/CcmCampaignPaymentsWithDataInvoice';

import './ccm-campaign-payments-invoice.scss';

import type { CampaignBrief } from 'types';
import type {
  CcmCampaignPaymentsState
} from '../redux/types/CcmCampaignPaymentsRedux.type';

type GlobalState = {
  campaignBrief: CampaignBrief,
  ccmCampaignPayments: CcmCampaignPaymentsState
};

interface StateProps {
  brandPayment: CcmCampaignPaymentsState['brandPayment'],
  isCampaignLive: boolean
}

type Props = StateProps;

const CcmCampaignPaymentsInvoice = ({
  brandPayment,
  isCampaignLive
}: Props) => (
  <div className="ccm-campaign-payments-invoice">
    {!isCampaignLive || brandPayment === null || brandPayment.campaignTotal === 0 ? (
      <CcmCampaignPaymentsEmptyInvoice />
    ) : (
      <CcmCampaignPaymentsWithDataInvoice payment={brandPayment} />
    )}
  </div>
);

const mapStateToProps = (
  {
    ccmCampaignPayments,
    campaignBrief
  }: GlobalState
): StateProps => ({
  brandPayment: ccmCampaignPayments.brandPayment,
  isCampaignLive: moment(campaignBrief.brief?.timeline?.taskContentGoLiveDate).isBefore()
});

export default connect(mapStateToProps)(CcmCampaignPaymentsInvoice);
